import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';
import { TokenAuth } from './Authguard/auth-interceptor';
import { AuthService } from './Authguard/auth.service';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule } from '@angular/forms';
import { ManageSiteDialogComponent } from './Components/Dialog/manage-site-dialog/manage-site-dialog.component';
import { AddZoneGeofsComponent } from './Components/Dialog/add-zone-geofs/add-zone-geofs.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [AppComponent, ManageSiteDialogComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    JwtModule,
    CommonModule,
    MatProgressBarModule,
    FormsModule,
    GoogleMapsModule,
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenAuth,
    multi: true
  }, AuthService
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
